import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "default-form" }
const _hoisted_4 = { class: "input-row" }
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = {
  key: 1,
  class: "error-hint"
}
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = { class: "input-wr" }
const _hoisted_10 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_11 = { class: "input-row" }
const _hoisted_12 = { class: "input-wr" }
const _hoisted_13 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_14 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "title-main" }, "Change password", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "Current password", -1)),
            _createVNode($setup["InputPassword"], {
              modelValue: $setup.form.currentPassword,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => (($setup.form.currentPassword) = $event)),
                _cache[1] || (_cache[1] = ($event: any) => ($setup.currentPassError = ''))
              ],
              "input-classes": ['input', { error: $setup.v$.currentPassword.$error || $setup.currentPassError }],
              type: "text",
              placeholder: "Type your password"
            }, null, 8, ["modelValue", "input-classes"]),
            ($setup.currentPassError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.currentPassError), 1))
              : _createCommentVNode("", true),
            ($setup.v$.currentPassword.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.v$.currentPassword.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label" }, "New password", -1)),
            _createVNode($setup["InputPassword"], {
              modelValue: $setup.form.newPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.newPassword) = $event)),
              "input-classes": ['input', { error: $setup.v$.newPassword.$error }],
              onBlur: $setup.v$.newPassword.$touch,
              type: "text",
              placeholder: "New password"
            }, null, 8, ["modelValue", "input-classes", "onBlur"]),
            ($setup.v$.newPassword.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.v$.newPassword.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label" }, "Confirm new password", -1)),
            _createVNode($setup["InputPassword"], {
              modelValue: $setup.form.confirmPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.confirmPassword) = $event)),
              "input-classes": ['input', { error: $setup.v$.confirmPassword.$error }],
              type: "text",
              placeholder: "Confirm new password"
            }, null, 8, ["modelValue", "input-classes"]),
            ($setup.v$.confirmPassword.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.v$.confirmPassword.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode($setup["PasswordProgress"], {
          class: "progress-bar",
          password: $setup.form.newPassword
        }, null, 8, ["password"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "button default primary",
          onClick: $setup.changePassword
        }, "Save"),
        _createVNode(_component_router_link, {
          class: "button default cancel",
          to: { name: 'LandownerProfile' }
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}